var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0c-58.407 0-105.925 47.518-105.925 105.925 0 53.316 39.597 97.55 90.925 104.858V1024h30V210.784c51.329-7.309 90.925-51.543 90.925-104.859C361.925 47.518 314.407 0 256 0z"
  })));
}
export default SvgPinAlt;